/**
 * Purchase order edit — mounts the shared composer in edit mode by
 * threading `loadPoId`. The composer hydrates from `purchaseOrders.get`,
 * gates on draft-only editability, and saves via `purchaseOrders.update`.
 *
 * @see prototype/purchases/purchase-order-new.html — V1.1 composer baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { PoComposerPage } from "../../../../features/purchase-orders/index.ts";

export const Route = createFileRoute("/(workspace)/procurement/purchase-orders/$poId/edit")({
  component: EditPurchaseOrderRoute,
});

function EditPurchaseOrderRoute() {
  const { poId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Purchase orders", to: "/procurement/purchase-orders" },
        { label: "Edit" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <PoComposerPage loadPoId={poId} />
    </WorkspaceShell>
  );
}
